export const generateUniqueId = () => {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0,
      v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};


export const generateLabel = (data) => {
  const { givenName, displayName, mobileNumber } = data;

  // Filter fields based on their length being greater than 0
  const parts = [givenName, displayName, mobileNumber].filter((part) => part && part.length > 0);

  // Join non-empty parts with a space
  return parts.join(" ");
};